export const ROUTES = {
  HOMEPAGE: '/',

  // Profile
  PROFILE: '/profile',
  PROFILE_EDIT: '/profile/edit',

  // Authentication
  LOGIN: '/login',
  OTP: '/otp',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_PASSWORD_OTP: '/forgot-password/otp',
  FORGOT_PASSWORD_SUCCESS: '/forgot-password/success',
  RESET_PASSWORD: '/reset-password/:uuid',
  ACTIVATION: '/activation/:uuid',
  ACTIVATION_SET_PASSWORD: '/set-password',
  ACTIVATION_EXPIRED: '/activation-expired',
  ACTIVATION_RESEND: '/activation-resend',

  // Program Settings
  PROGRAM_SETTINGS_GENERAL: '/program-settings',
  PROGRAM_SETTINGS_DOCUMENT_LINKS: '/program-settings/document-links',
  PROGRAM_SETTINGS_BRANDING_THEMES: '/program-settings/branding-themes',

  // Branding Themes
  BRANDING_THEMES: '/branding-themes',
  BRANDING_THEME_ADD: '/branding-themes/add',
  BRANDING_THEME_EDIT: '/branding-themes/edit/:brandingThemeId',
  BRANDING_THEME_EDIT_PARAMS: '/branding-themes/edit',
  BRANDING_THEME_VIEW: '/branding-themes/view/:brandingThemeId',
  BRANDING_THEME_VIEW_PARAMS: '/branding-themes/view',

  // Staff
  STAFF: '/staff',
  STAFF_DETAILS: '/staff/:uuid',
  STAFF_EDIT: '/staff/edit/:uuid',
  STAFF_EDIT_PARAMS: '/staff/edit',
  STAFF_ADD: '/staff/add',

  // Companies
  COMPANIES: '/companies',
  COMPANIES_DETAIL: '/companies/:uuid',
  COMPANIES_EDIT: '/companies/edit/:uuid',
  COMPANIES_EDIT_PARAMS: '/companies/edit',
  COMPANIES_ADD: '/companies/add',

  // Customers
  CUSTOMERS: '/customers',
  CUSTOMERS_DETAIL: '/customers/:uuid',
  CUSTOMERS_EDIT: '/customers/edit/:uuid',
  CUSTOMERS_EDIT_PARAMS: '/customers/edit',
  CUSTOMERS_ADD: '/customers/add',
  CUSTOMERS_EXTERNAL_ACCOUNTS: '/customers/:uuid/external-accounts',
  CUSTOMERS_EXTERNAL_ACCOUNTS_ADD: '/customers/:uuid/external-accounts/add',

  // Wire Recipients
  WIRE_RECIPIENTS: '/wire-recipients',
  WIRE_REQUESTS: '/wire-requests',
  WIRE_RECIPIENTS_LIST: '/customers/:customerId/wire-recipients',
  WIRE_RECIPIENTS_DETAIL: '/customers/:customerId/wire-recipients/:uuid',
  WIRE_REQUESTS_DETAIL: '/customers/:customerId/wire-requests/:uuid',
  WIRE_RECIPIENTS_ADD: '/customers/:customerId/wire-recipients/add',

  // Businesses
  BUSINESSES: '/businesses',
  BUSINESSES_DETAIL: '/businesses/:uuid',
  BUSINESSES_EDIT: '/businesses/edit/:uuid',
  BUSINESSES_EDIT_PARAMS: '/businesses/edit',
  BUSINESSES_ADD: '/businesses/add',

  // Teammates
  TEAMMATES: '/teammates',
  TEAMMATES_DETAIL: '/teammates/:uuid',
  TEAMMATES_EDIT: '/teammates/edit/:uuid',
  TEAMMATES_EDIT_PARAMS: '/teammates/edit',
  TEAMMATES_ADD: '/teammates/add',

  // External Accounts
  EXTERNAL_ACCOUNTS: '/external-accounts',
  EXTERNAL_ACCOUNTS_DETAIL: '/external-accounts/:uuid',
  EXTERNAL_ACCOUNTS_ADD: '/external-accounts/add',
  EXTERNAL_ACCOUNTS_VERIFY: '/external-accounts/:uuid/verify',

  // Bank Accounts
  BANK_ACCOUNTS: '/bank-accounts',
  BANK_ACCOUNTS_DETAIL: '/bank-accounts/:uuid',
  BANK_ACCOUNTS_EDIT: '/bank-accounts/:uuid/edit',
  STATEMENTS: '/statements',
  BANK_ACCOUNTS_STATEMENTS_PARAMS: '/bank-accounts/:uuid/statements',
  TAX_DOCUMENTS: '/tax-documents',
  BANK_ACCOUNTS_TAX_DOCUMENTS_PARAMS: '/bank-accounts/:uuid/tax-documents',
  SCHEDULED_TRANSACTIONS: '/scheduled-transactions',
  BANK_ACCOUNTS_SCHEDULED_TRANSACTIONS_PARAMS:
    '/bank-accounts/:uuid/scheduled-transactions',
  BANK_ACCOUNTS_SCHEDULED_TRANSACTION_DETAILS_PARAMS:
    '/bank-accounts/:bankAccountId/scheduled-transactions/:uuid',

  // Transactions
  TRANSACTIONS: '/transactions',
  TRANSACTIONS_LIST: '/bank-accounts/:uuid/transactions',
  TRANSACTIONS_DETAILS: '/bank-accounts/:bankAccountId/transactions/:uuid',

  // Transactions
  TRANSACTION_REQUESTS: '/transaction-requests',
  TRANSACTION_REQUESTS_LIST:
    '/bank-accounts/:bankAccountId/transaction-requests',
  TRANSACTIONS_REQUESTS_DETAILS:
    '/bank-accounts/:bankAccountId/transaction-requests/:uuid',

  // Bank Account Applications
  BANK_ACCOUNT_APPLICATIONS: '/bank-account-applications',
  BANK_ACCOUNT_APPLICATION_EDIT: '/bank-account-applications/:uuid/edit',
  BANK_ACCOUNT_APPLICATION_DETAILS: '/bank-account-applications/:uuid',
  BANK_ACCOUNT_APPLICATIONS_DRAFT: '/bank-account-applications/draft',
  BANK_ACCOUNT_APPLICATIONS_ESIGN: '/bank-account-applications/awaiting-esign',
  BANK_ACCOUNT_APPLICATIONS_SUBMITTED: '/bank-account-applications/submitted',
  BANK_ACCOUNT_APPLICATIONS_EXTERNAL_ACCOUNT_REVIEW:
    '/bank-account-applications/external-account-review',
  BANK_ACCOUNT_APPLICATIONS_UNDER_REVIEW:
    '/bank-account-applications/under-review',
  BANK_ACCOUNT_APPLICATIONS_COMPLETED: '/bank-account-applications/completed',

  // Transaction Review
  TRANSACTION_REVIEW: '/transaction-review',
  TRANSACTION_REVIEW_DETAILS: '/transaction-review/:uuid',

  // Lending
  LENDING: '/lending',
  LENDING_DETAILS: '/lending/:uuid',
};
